import { render } from "./TaskCustomFieldList.vue?vue&type=template&id=d88965fe"
import script from "./TaskCustomFieldList.vue?vue&type=script&lang=js"
export * from "./TaskCustomFieldList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__